module.exports = [
  ...require('./_gearRawList_l'),
  require('./lance'),
  require('./laser_pistol'),
  require('./laser_rifle'),
  require('./longbow'),
  require('./longsword'),
]
